import http from 'plugins/axios';

export default {
  getRecords(data) {
    return http.get({
      url: '/la/admin/starplan/getList',
      data
    });
  },
  setNode(data) {
    return http.post({
      url: '/la/admin/starplan/create/node',
      data,
      dataType: 'form'
    });
  },
  gettime(data) {
    return http.get({
      url: '/la/admin/starplan/getInitDate',
      data
    });
  },
  settime(data) {
    return http.post({
      url: '/la/admin/starplan/setInitDate',
      data,
      dataType: 'form'
    });
  },
  removeNode(data) {
    return http.post({
      url: '/la/admin/starplan/deleteByNodeId',
      data,
      dataType: 'form'
    });
  },
  changeNode(data) {
    return http.post({
      url: '/la/admin/starplan/updateByNodeId ',
      data
    });
  },
  Nodepeople(data) {
    return http.get({
      url: '/la/admin/newperson/getListByNode',
      data
    });
  },
  nodeList(data) {
    return http.get({
      url: '/la/admin/newperson/getAllNodeCount',
      data
    });
  },
  setsort(data) {
    return http.post({
      url: '/la/admin/starplan/updateSrot',
      data,
      dataType: 'form'
    });
  }
};
